export default __webpack_public_path__ + "static/media/action-close_darkGray2.54eb9e3f.svg";